import { j as r } from "./jsx-runtime-944c88e2.js";
import * as m from "react";
import { C as d } from "./Chip-cb37946d.js";
import { Icon as s } from "./icon.js";
import { c as n } from "./form-2514c6d8.js";
import "./index-efd35e77.js";
import "./package-metadata-9ad1330d.js";
import "./index-64063129.js";
import "./theme-b013fa81.js";
import "./keys-2b65407d.js";
import "./FormElement-65f04cfd.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./index-93802845.js";
import "./index-c07310bf.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
const a = (t) => /* @__PURE__ */ r.jsxs(d, { ...t, rounded: "full", fillMode: "outline", themeColor: t.isError ? "error" : "base", children: [
  t.iconName && /* @__PURE__ */ r.jsx(s, { color: "secondary", icon: t.iconName, size: t.iconSize ?? "lg", style: { paddingRight: "4px" } }),
  t.children
] }), V = ({
  validationMessage: t,
  touched: i,
  modified: c,
  visited: x,
  label: u,
  hint: f,
  fieldWrapperClassName: g,
  onChange: o,
  ...e
}) => {
  const l = i && t && i;
  return m.useMemo(() => o({ value: e.triggerOnChange }), [e.triggerOnChange]), /* @__PURE__ */ r.jsx(n, { children: /* @__PURE__ */ r.jsx(
    a,
    {
      ...e,
      className: "mt-4",
      role: "checkbox",
      isError: l,
      onClick: () => {
        o({ value: !(e.selected && !e.disabled) && "true" });
      },
      selected: e.selected && !e.disabled,
      children: l ? /* @__PURE__ */ r.jsx("div", { className: "text-red-500", children: t }) : /* @__PURE__ */ r.jsx("div", { children: e.selected ? e.selectedText : e.unselectedText })
    }
  ) });
};
export {
  a as Chip,
  V as FormElementChip
};
